<div *ngIf="form" class="relative">
    <h4 class="overline-o2 grey-700 ml-4">{{'plugins.applications' | translate }}</h4>
    <!-- INFO BANNER -->
    <div *ngIf="form.disabled" class="flex items-center justify-between bg-primary-100 py-4 px-6 m-4">
      <div class="text-left mr-4">
        <h3 class="title-t2">{{'organizationData.enlarge' | translate}}</h3>
        <p class="body-b2">{{'organizationData.enlargeDetail' | translate}}</p>
      </div>
      <a [href]="'mailto:' + CONTACT_EMAIL" class="w-1/3">
        <app-button-secondary type="button" class="flex items-center">
          <mat-icon svgIcon="arrow-right" color="primary" class="-mb-1"></mat-icon>
          {{'organizationData.contactTeam' | translate}}
        </app-button-secondary>
      </a>
    </div>

    <div class="mx-4 flex flex-col items-start pb-4">
      <!-- CARGOX UTILIZA EL AVAILABLE EN EL CHECK EN VEZ DEL ENABLED PARA QUE SE LO HABILITEN DESDE BO -->
      <app-toggle-card [control]="form.get('cargox.available') | cast" [icon]="icons.cargox" [label]="'plugins.cargox' | translate" [description]="'plugins.cargoXDescription' | translate" class="w-full"></app-toggle-card>
      <app-toggle-card [control]="form.get('iaDataExtraction.enabled') | cast" [icon]="icons.iaDataExtraction" [label]="'plugins.iaDataExtraction' | translate" [description]="'plugins.iaDescription' | translate" data-test="iaDataExtractionCheck" class="w-full"></app-toggle-card>
      <app-toggle-card [control]="form.get('splitDocuments.enabled') | cast" [icon]="icons.draftDocuments" [label]="'plugins.iaDocumentDivision' | translate" [description]="'plugins.iaDocumentDivisionDescription' | translate" class="w-full"></app-toggle-card>

      <!--TOGGLE EDOCS API-->
      <app-toggle-card [control]="form.get('edocsApi.enabled') | cast " [icon]="icons.edocsApi" [label]="'plugins.edocsApi' | translate" [description]="'plugins.edocsApiDescription' | translate" class="w-full">
        <div class="bg-grey-100 w-full bg-grey-100">
          <div class="flex items-center justify-between border-top mt-6 px-6">
            <h3>{{'edocs.contractedDocuments' | translate}}</h3>
            <app-button-secondary class="flex items-center justify-between">
              <mat-icon [svgIcon]="'plus'" color="primary" class="mr-2"></mat-icon>
              <span class="pb-6">{{'buttons.addNew' | translate}}</span>
            </app-button-secondary>
          </div>
        </div>
      </app-toggle-card>

      <!--TOGGLE POWERBI-->
      <app-toggle-card [control]="form.get('powerBi.enabled') | cast " [isExpandable]="true" [icon]="icons.powerBi" [label]="'plugins.powerBi' | translate" [description]="'plugins.powerBiDescription' | translate" [panelExpanded]="true" class="w-full">
        <div class="bg-grey-100 w-full bg-grey-100">
          <div class="w-full border-top mt-6">
            <div class="w-1/2 mt-4">
              <app-input [type]="'text'" [control]="form.get('powerBi.url')" [label]="('plugins.url' | translate)" [placeholder]="'plugins.urlPlaceholder' | translate" class=" mt-4"></app-input>
            </div>
          </div>
        </div>
      </app-toggle-card>

      <!--TOGGLE ADAM-->
      <app-toggle-card [control]="form.get('adam.enabled') | cast " [icon]="icons.adam" [label]="'plugins.adam' | translate" [description]="'plugins.adamDescription' | translate" class="w-full" />

      <!--TOGGLE E-DOCS (MASTER + CHIPS)-->
      <app-toggle-card [control]="form.get('edocs.enabled') | cast" [isExpandable]="true" [icon]="icons.edocs" [label]="'plugins.edocsGroup' | translate" [description]="'plugins.edocsGroupDescription' | translate" [panelExpanded]="form.get('edocs.enabled')?.value" class="w-full">
        <div class="border-top mt-6 px-6 pb-4">
          <div class="flex flex-wrap gap-2 mt-4">
            <mat-chip-listbox multiple>
              <mat-chip-option
                *ngFor="let chip of edocChips"
                [selected]="form.get('edocs.enabled')?.value && form.get('edocs.config.' + chip.key + '.enabled')?.value"
                [disabled]="!form.get('edocs.enabled')?.value || form.get('edocs.config.' + chip.key + '.enabled')?.disabled"
                (selectionChange)="form.get('edocs.config.' + chip.key + '.enabled')?.setValue($event.selected)"
                color="primary">
                <mat-icon [svgIcon]="chip.icon" matChipAvatar></mat-icon>
                {{ chip.label | translate }}
              </mat-chip-option>
            </mat-chip-listbox>
          </div>
        </div>
      </app-toggle-card>

      <!-- GESINFLOT -->
      <app-toggle-card [control]="form.get('gesinflot.enabled') | cast" [icon]="icons.gesinflot" [isExpandable]="true" [label]="'plugins.gesinflot' | translate" [description]="'plugins.gesinflotDescription' | translate" class="w-full">
        <div class="border-top mt-6">
          <div class="w-1/2 mt-4">
            <app-input [type]="'text'" [control]="form.get('gesinflot.url')" [label]="('plugins.url' | translate)" [placeholder]="'plugins.urlPlaceholder' | translate" class=" mt-4"></app-input>
          </div>

          <div class="flex space-x-2">
            <app-input [type]="'text'" [control]="form.get('gesinflot.user')" [label]="('plugins.user' | translate)" [placeholder]="'plugins.userPlaceholder' | translate" class="flex-1"></app-input>
            <app-input [type]="'password'" [control]="form.get('gesinflot.password')" [label]="('plugins.password' | translate)" [placeholder]="'plugins.passwordPlaceholder' | translate" class="flex-1"></app-input>
          </div>
        </div>
      </app-toggle-card>

      <!--DEV MODE-->
      <app-toggle-card [control]="form.get('developerMode.enabled') | cast " [isExpandable]="true" [icon]="icons.developerMode" [label]="'plugins.developerMode' | translate" [description]="'plugins.developerModeDescription' | translate" [panelExpanded]="true" class="w-full">
        <div class="bg-grey-100 w-full bg-grey-100">
          <div class="w-full border-top mt-6">
            <div class="w-full mt-4">
              <div class="w-1/2">
                <app-user-multiple-select
                  [control]="form.get('developerMode.docAiDeveloperMode')"
                  [users]="users"
                  [label]="'plugins.docAiDeveloperMode' | translate"
                ></app-user-multiple-select>
              </div>
              <div class="w-1/2 mt-4">
                <app-user-multiple-select
                  [control]="form.get('developerMode.fieldReferenceInfo')"
                  [users]="users"
                  [label]="'plugins.fieldReferenceInfo' | translate"
                ></app-user-multiple-select>
              </div>
            </div>
          </div>
        </div>
      </app-toggle-card>

    </div>

  <div class="w-full sticky bottom-0 bg-grey-50 border-top flex justify-end">
    <app-button-secondary (click)="save()" class="m-4">{{'buttons.save' | translate}}</app-button-secondary>
  </div>
</div>
